var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFrag5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.495 30.5545C12.4737 30.5545 9.52018 29.6585 7.00801 27.9798C4.49583 26.3011 2.53782 23.9152 1.38159 21.1236C0.22536 18.3321 -0.0771499 15.2603 0.51229 12.2968C1.10173 9.33331 2.55664 6.61116 4.69307 4.4746C6.8295 2.33804 9.55148 0.883035 12.5148 0.293558C15.4781 -0.295918 18.5496 0.00661082 21.341 1.16291C24.1324 2.31921 26.5183 4.27734 28.1969 6.78968C29.8754 9.30201 30.7713 12.2557 30.7713 15.2773C30.7665 19.3275 29.1555 23.2105 26.2917 26.0745C23.4278 28.9385 19.5451 30.5497 15.495 30.5545ZM15.495 2.10341C12.889 2.10295 10.3414 2.8754 8.17436 4.32304C6.00733 5.77068 4.31826 7.82848 3.32076 10.2362C2.32327 12.6439 2.06218 15.2934 2.57048 17.8495C3.07878 20.4057 4.33364 22.7536 6.17638 24.5965C8.01912 26.4393 10.367 27.6943 12.923 28.2026C15.4789 28.711 18.1282 28.4498 20.5358 27.4523C22.9434 26.4547 25.001 24.7656 26.4486 22.5984C27.8961 20.4313 28.6685 17.8834 28.6681 15.2773C28.6638 11.7846 27.2746 8.43629 24.8051 5.96663C22.3356 3.49698 18.9874 2.10766 15.495 2.10341Z",
    fill: "#20E0BC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrag5);
export default __webpack_public_path__ + "static/media/frag5.f3668eb71b2be03deaebbf7a1e4271ae.svg";
export { ForwardRef as ReactComponent };